import React from "react";
import { useTranslation } from "react-i18next";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import ScrollableCard from "../../../../SharedComponents/ScrollableCard";
import IconSvg from "../../../../SharedComponents/IconSvg";

const ApplicationCardContent = ({ companyCredit, isVitrine }) => {
  const { t } = useTranslation();

  return (
    <>
      <Row className="justify-content-center">
        <IconSvg icon="packet" />
      </Row>

      <Row className="justify-content-center">
        <Col xs="auto" className="text-24 text-color-gray-dark fw-medium text-center">
          {companyCredit.assessment.name}
        </Col>
      </Row>

      {!isVitrine && (
        <Row className="justify-content-center">
          <Col xs="auto" className="text-16 text-color-gray-light fw-medium">
            {companyCredit.creditAmount} {t("credit")}
          </Col>
        </Row>
      )}

      <ScrollableCard emptySpaceHeight={25}>
        <Row className="mx-0">
          {companyCredit.assessment.inventories.map((inventory, i) => (
            <Card key={`I${i}`} className="assessment-row">
              <Row className="justify-content-between m-0">
                <Col xs="auto">{inventory.name}</Col>
                <Col xs="auto"></Col>
              </Row>
            </Card>
          ))}
        </Row>

        <Row className="mx-0">
          {companyCredit.assessment.surveys.map((survey, i) => (
            <Card key={`S${i}`} className="assessment-row">
              <Row className="justify-content-between m-0">
                <Col xs="auto">{survey.name}</Col>
                <Col xs="auto"></Col>
              </Row>
            </Card>
          ))}
        </Row>

        <Row className="mx-0">
          {companyCredit.assessment.tests.map((test, i) => (
            <Card key={`T${i}`} className="assessment-row">
              <Row className="justify-content-between m-0">
                <Col xs="auto">{test.name}</Col>
                <Col xs="auto"></Col>
              </Row>
            </Card>
          ))}
        </Row>
      </ScrollableCard>
    </>
  );
};

export default ApplicationCardContent;
